<template>
  <div>
    <el-scrollbar height="100%" class="ShowCreateMelkUser" ref="scrollbar">
      <!-- <div class="TopShowBackToPage"> -->
      <div class="createMelkHeader phoneBookHeader">
        <div class="createMelkHeaderContainer">
          <div class="createMelkHeaderTitle">
            <h1>لیست متقاضیان</h1>
          </div>
          <div class="showFormBtn" @click="formTypeHandler('form')">
            <i class="fa-solid fa-plus"></i>
          </div>
          <div @click="closeBtn" class="ShowIconVsIcon">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>
        </div>
      </div>
      <div class="phoneBookMain noteBook">
        <div class="phoneBookMainContainer notBook">
          <div
            class="containerSideForm"
            v-if="!showDetails"
            :class="{ show: showForm }"
          >
            <div class="formHeader">
              <div class="formHeaderTitle" v-if="!editMenu">افزودن متقاضی</div>
              <div class="formHeaderTitle" v-if="editMenu">ویرایش متقاضی</div>
              <div class="formResetBtn" v-if="editMenu" @click="clear_form()">
                متقاضی جدید
              </div>
              <div class="ShowIconVsIcon" @click="formCloseHandler('form')">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="formMain">
              <form class="addPhoneForm addRequestForm">
                <!--                <div-->
                <!--                  class="formGroup"-->
                <!--                  :class="[-->
                <!--                    { focused: selectFocus.user_id },-->
                <!--                    { filled: form.user_id != '' },-->
                <!--                  ]"-->
                <!--                >-->
                <!--                  <el-select-->
                <!--                    v-model="form.user_id"-->
                <!--                    placeholder=""-->
                <!--                    @focus="inputFocusHandler('user_id')"-->
                <!--                    @blur="inputBlurHandler('user_id')"-->
                <!--                    @change="inputBlurHandler('user_id')"-->
                <!--                  >-->
                <!--                    <el-option-->
                <!--                      v-for="(v, i) in users_list"-->
                <!--                      :key="i"-->
                <!--                      :value="v.uid"-->
                <!--                      :label="v.nickname"-->
                <!--                    />-->
                <!--                  </el-select>-->
                <!--                  <label class="formGroupLabel">متقاضی <span>*</span></label>-->
                <!--                </div>-->

                <div class="formGroup">
                  <input
                    type="text"
                    placeholder=""
                    class="formGroupTextInput"
                    v-model="form.nickname"
                    maxlength="240"
                  />
                  <label class="formGroupLabel">
                    نام و نام خانوادگی متقاضی <span>* </span></label
                  >
                </div>

                <div class="formGroup">
                  <input
                    placeholder=""
                    class="formGroupTextInput text-left"
                    v-model="form.mobile"
                    type="text"
                    maxlength="11"
                    inputmode="numeric"
                    dir="ltr"
                    @input="onMobileInput"
                  />
                  <label class="formGroupLabel">
                    شماره تماس متقاضی <span>* </span>
                  </label>
                </div>

                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.status },
                    { filled: form.status != '' },
                  ]"
                >
                  <el-select
                    v-model="form.status"
                    placeholder=""
                    @focus="inputFocusHandler('status')"
                    @blur="inputBlurHandler('status')"
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.request_status"
                      :key="i"
                      :value="i"
                      :label="v"
                    />
                  </el-select>
                  <label class="formGroupLabel">وضعیت <span>* </span></label>
                </div>

                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.main_category },
                    { filled: form.main_category != '' },
                  ]"
                >
                  <el-select
                    v-model="form.main_category"
                    placeholder=""
                    @focus="inputFocusHandler('main_category')"
                    @blur="inputBlurHandler('main_category')"
                    @change="inputBlurHandler('main_category')"
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.main_category2"
                      :key="i"
                      :value="i"
                      :label="v"
                    />
                  </el-select>
                  <label class="formGroupLabel"
                    >نوع درخواست <span>* </span></label
                  >
                </div>
                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.category },
                    { filled: form.category != '' },
                  ]"
                >
                  <el-select
                    v-model="form.category"
                    placeholder=""
                    @focus="inputFocusHandler('category')"
                    @blur="inputBlurHandler('category')"
                    @change="
                      () => {
                        inputBlurHandler('category');
                        get_sub_category();
                      }
                    "
                  >
                    <el-option value="apartment" label="آپارتمان"> </el-option>
                    <el-option value="villa_house" label="خانه حیاط دار">
                    </el-option>
                    <el-option value="villa" label="ویلا"> </el-option>
                    <el-option value="Administrative" label="اداری">
                    </el-option>

                    <el-option
                      v-if="form.main_category != 'rent'"
                      value="garden"
                      label="باغ"
                    >
                    </el-option>
                    <el-option
                      v-if="form.main_category != 'rent'"
                      value="land"
                      label="زمین"
                    >
                    </el-option>
                    <el-option value="commercial" label="تجاری"> </el-option>
                    <el-option value="industrial" label="صنعتی"> </el-option>
                  </el-select>
                  <label class="formGroupLabel">گروه <span>*</span></label>
                </div>
                <div
                  class="groupFlexWrapper"
                  v-if="
                    form.category === 'villa_house' ||
                    form.category === 'garden' ||
                    form.category === 'land'
                  "
                >
                  <div class="groupFlexLabel">
                    <div class="groupLabel">متراژ زمین <span>*</span></div>
                  </div>
                  <div class="groupFlex">
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.land_area"
                        @input="numberInputHandler($event, 'land_area')"
                      />
                      <label class="formGroupLabel">از</label>
                    </div>
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.land_area_max"
                        @input="numberInputHandler($event, 'land_area_max')"
                      />
                      <label class="formGroupLabel">تا</label>
                    </div>
                  </div>
                </div>
                <div class="groupFlexWrapper">
                  <div class="groupFlexLabel">
                    <div
                      class="groupLabel"
                      v-if="
                        form.category === 'apartment' ||
                        form.category === 'Administrative' ||
                        form.category === 'industrial' ||
                        form.category === 'commercial'
                      "
                    >
                      متراژ <span>*</span>
                    </div>
                    <div class="groupLabel" v-else>
                      متراژ بنا <span>*</span>
                    </div>
                  </div>
                  <div class="groupFlex">
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.building_area"
                        @input="numberInputHandler($event, 'building_area')"
                      />
                      <label class="formGroupLabel">از</label>
                    </div>
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.building_area_max"
                        @input="numberInputHandler($event, 'building_area_max')"
                      />
                      <label class="formGroupLabel">تا</label>
                    </div>
                  </div>
                </div>
                <div
                  class="groupFlexWrapper"
                  v-if="form.category !== 'garden' && form.category !== 'land'"
                >
                  <div class="groupFlexLabel">
                    <div class="groupLabel">سال ساخت <span>*</span></div>
                  </div>
                  <div class="groupFlex">
                    <div
                      class="formGroup"
                      :class="[
                        { focused: selectFocus.completion_date },
                        { filled: form.completion_date != '' },
                      ]"
                    >
                      <el-select
                        class="formSelectInput"
                        v-model="form.completion_date"
                        placeholder=""
                        @focus="inputFocusHandler('completion_date')"
                        @blur="inputBlurHandler('completion_date')"
                        @change="inputBlurHandler('completion_date')"
                      >
                        <el-option :value="'new_build'" :label="'نوساز'" />
                        <el-option :value="'1 سال'" :label="'1 سال'" />
                        <el-option :value="'2 سال'" :label="'2 سال'" />
                        <el-option :value="'5 سال'" :label="'5 سال'" />
                        <el-option :value="'10 سال'" :label="'10 سال'" />
                        <el-option :value="'15 سال'" :label="'15 سال'" />
                        <el-option :value="'20 سال'" :label="'20 سال'" />
                        <el-option
                          :value="'بیش از 20 سال'"
                          :label="'بیش از 20 سال'"
                        />
                      </el-select>
                      <label class="formGroupLabel">از</label>
                    </div>
                    <div
                      class="formGroup"
                      :class="[
                        { focused: selectFocus.completion_date_max },
                        { filled: form.completion_date_max != '' },
                      ]"
                    >
                      <el-select
                        class="formSelectInput"
                        v-model="form.completion_date_max"
                        placeholder=""
                        @focus="inputFocusHandler('completion_date_max')"
                        @blur="inputBlurHandler('completion_date_max')"
                        @change="inputBlurHandler('completion_date_max')"
                      >
                        <el-option :value="'new_build'" :label="'نوساز'" />
                        <el-option :value="'1 سال'" :label="'1 سال'" />
                        <el-option :value="'2 سال'" :label="'2 سال'" />
                        <el-option :value="'5 سال'" :label="'5 سال'" />
                        <el-option :value="'10 سال'" :label="'10 سال'" />
                        <el-option :value="'15 سال'" :label="'15 سال'" />
                        <el-option :value="'20 سال'" :label="'20 سال'" />
                        <el-option
                          :value="'بیش از 20 سال'"
                          :label="'بیش از 20 سال'"
                        />
                      </el-select>
                      <label class="formGroupLabel">تا</label>
                    </div>
                  </div>
                </div>
                <div
                  class="formGroup"
                  v-if="form.main_category != 'rent'"
                  :class="[
                    { focused: selectFocus.doc_type },
                    { filled: form.doc_type != '' },
                  ]"
                >
                  <el-select
                    v-model="form.doc_type"
                    placeholder=""
                    @focus="inputFocusHandler('doc_type')"
                    @blur="inputBlurHandler('doc_type')"
                    @change="inputBlurHandler('doc_type')"
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.doc_type"
                      :key="i"
                      :value="i"
                      :label="v"
                    />
                  </el-select>
                  <label class="formGroupLabel">نوع سند <span>*</span></label>
                </div>
                <div
                  class="formGroup"
                  v-if="
                    form.category === 'commercial' ||
                    form.category === 'industrial'
                  "
                >
                  <input
                    type="text"
                    placeholder=""
                    inputmode="numeric"
                    class="formGroupTextInput numberInput"
                    v-model="front_show.width"
                    @input="numberInputHandler($event, 'width')"
                  />
                  <label class="formGroupLabel">متراژ دهنه ملک</label>
                </div>
                <div
                  class="formGroup"
                  v-if="
                    form.category !== 'commercial' &&
                    form.category !== 'industrial' &&
                    form.category !== 'garden' &&
                    form.category !== 'land'
                  "
                  :class="[
                    { focused: selectFocus.bedroom },
                    { filled: form.bedroom != '' },
                  ]"
                >
                  <el-select
                    class="formSelectInput"
                    v-model="form.bedroom"
                    placeholder=""
                    @focus="inputFocusHandler('bedroom')"
                    @blur="inputBlurHandler('bedroom')"
                    @change="inputBlurHandler('bedroom')"
                  >
                    <el-option :value="0" :label="'بدون اتاق'"></el-option>
                    <el-option
                      v-for="i in 4"
                      :key="i"
                      :value="i"
                      :label="`${i} اتاق`"
                    >
                    </el-option>
                    <el-option :value="5" :label="'بیش از 4 اتاق'"> </el-option>
                  </el-select>
                  <label class="formGroupLabel"
                    >تعداد اتاق <span>*</span></label
                  >
                </div>
                <div
                  class="formGroup"
                  v-if="
                    form.category !== 'commercial' &&
                    form.category !== 'industrial' &&
                    form.category !== 'garden' &&
                    form.category !== 'land'
                  "
                  :class="[
                    { focused: selectFocus.parking },
                    { filled: form.parking != '' },
                  ]"
                >
                  <el-select
                    class="formSelectInput"
                    v-model="form.parking"
                    placeholder=""
                    @focus="inputFocusHandler('parking')"
                    @blur="inputBlurHandler('parking')"
                    @change="inputBlurHandler('parking')"
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    />
                  </el-select>
                  <label class="formGroupLabel">پارکینگ</label>
                </div>
                <div
                  class="formGroup"
                  v-if="form.category === 'garden' || form.category === 'land'"
                >
                  <input
                    type="text"
                    placeholder=""
                    inputmode="numeric"
                    class="formGroupTextInput numberInput"
                    v-model="front_show.passage_width"
                    @input="numberInputHandler($event, 'passage_width')"
                  />
                  <label class="formGroupLabel">عرض کوچه</label>
                </div>
                <div
                  class="formGroup"
                  v-if="form.category === 'garden' || form.category === 'land'"
                >
                  <input
                    type="text"
                    placeholder=""
                    inputmode="numeric"
                    class="formGroupTextInput numberInput"
                    v-model="front_show.width"
                    @input="numberInputHandler($event, 'width')"
                  />
                  <label class="formGroupLabel">عرض زمین</label>
                </div>
                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.sub_category },
                    { filled: form.sub_category != '' },
                  ]"
                  v-if="
                    form.main_category != 'rent' &&
                    (form.category == 'land' ||
                      form.category == 'Administrative')
                  "
                >
                  <el-select
                    class="formSelectInput"
                    v-model="form.sub_category"
                    filterable
                    :clearable="true"
                    placeholder=""
                    @focus="inputFocusHandler('sub_category')"
                    @blur="inputBlurHandler('sub_category')"
                    @change="inputBlurHandler('sub_category')"
                  >
                    <el-option
                      v-for="(v, i) in front_show.sub_category_list"
                      :key="i"
                      :value="v.value"
                      :label="v.label"
                    >
                    </el-option>
                  </el-select>
                  <label class="formGroupLabel">نوع کاربری</label>
                </div>
                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.building_license_date },
                    { filled: form.building_license_date != '' },
                  ]"
                  v-if="
                    form.main_category != 'rent' && form.category == 'villa'
                  "
                >
                  <el-select
                    class="formSelectInput"
                    v-model="form.building_license_date"
                    placeholder=""
                    @focus="inputFocusHandler('building_license_date')"
                    @blur="inputBlurHandler('building_license_date')"
                    @change="inputBlurHandler('building_license_date')"
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                  <label class="formGroupLabel">پروانه ساخت</label>
                </div>
                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.elevator },
                    { filled: form.elevator != '' },
                  ]"
                  v-if="
                    form.category !== 'villa_house' &&
                    form.category !== 'commercial' &&
                    form.category !== 'industrial' &&
                    form.category !== 'land' &&
                    form.category !== 'garden'
                  "
                >
                  <el-select
                    class="formSelectInput"
                    v-model="form.elevator"
                    placeholder=""
                    @focus="inputFocusHandler('elevator')"
                    @blur="inputBlurHandler('elevator')"
                    @change="inputBlurHandler('elevator')"
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                  <label class="formGroupLabel">آسانسور</label>
                </div>
                <div
                  class="groupFlexWrapper"
                  v-if="form.main_category === 'trade'"
                >
                  <div class="groupFlexLabel">
                    <div class="groupLabel">قیمت(تومان) <span>*</span></div>
                  </div>
                  <div class="groupFlex">
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.total_price"
                        @input="numberInputHandler($event, 'total_price')"
                      />
                      <label class="formGroupLabel">از</label>
                    </div>
                    <div class="formGroup">
                      <input
                        type="text"
                        inputmode="numeric"
                        placeholder=""
                        class="formGroupTextInput numberInput"
                        v-model="front_show.total_price_max"
                        @input="numberInputHandler($event, 'total_price_max')"
                      />
                      <label class="formGroupLabel">تا</label>
                    </div>
                  </div>
                </div>
                <div
                  class="groupFlexWrapper"
                  v-if="form.main_category === 'rent'"
                >
                  <div class="groupFlexLabel">
                    <div class="groupLabel">مبلغ رهن(تومان) <span>*</span></div>
                  </div>
                  <div class="groupFlex">
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.mortgage_price"
                        @input="numberInputHandler($event, 'mortgage_price')"
                      />
                      <label class="formGroupLabel">از</label>
                    </div>
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.mortgage_price_max"
                        @input="
                          numberInputHandler($event, 'mortgage_price_max')
                        "
                      />
                      <label class="formGroupLabel">تا</label>
                    </div>
                  </div>
                </div>
                <div
                  class="groupFlexWrapper"
                  v-if="form.main_category === 'rent'"
                >
                  <div class="groupFlexLabel">
                    <div class="groupLabel">
                      مبلغ اجاره(تومان) <span>*</span>
                    </div>
                  </div>
                  <div class="groupFlex">
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.rent_price"
                        @input="numberInputHandler($event, 'rent_price')"
                      />
                      <label class="formGroupLabel">از</label>
                    </div>
                    <div class="formGroup">
                      <input
                        type="text"
                        placeholder=""
                        inputmode="numeric"
                        class="formGroupTextInput numberInput"
                        v-model="front_show.rent_price_max"
                        @input="numberInputHandler($event, 'rent_price_max')"
                      />
                      <label class="formGroupLabel">تا</label>
                    </div>
                  </div>
                </div>
                <div
                  class="formGroup"
                  :class="[
                    { focused: selectFocus.districts },
                    { filled: form.districts != [] },
                  ]"
                  v-if="
                    form.category !== 'villa_house' &&
                    form.category !== 'commercial' &&
                    form.category !== 'industrial' &&
                    form.category !== 'land' &&
                    form.category !== 'garden'
                  "
                >
                  <el-select
                    class="formSelectInput"
                    v-model="form.districts"
                    multiple
                    collapse-tags
                    :multiple-limit="6"
                    collapse-tags-tooltip
                    placeholder=""
                    @focus="inputFocusHandler('districts')"
                    @blur="inputBlurHandler('districts')"
                  >
                    <el-option
                      v-for="(v, i) in front_show.district_list"
                      :key="i"
                      :value="v.key"
                      :label="v.label"
                    >
                    </el-option>
                  </el-select>
                  <label class="formGroupLabel">منطقه</label>
                </div>
                <div class="formGroup">
                  <textarea
                    rows="3"
                    placeholder=""
                    v-model="form.details"
                    class="formGroupTextInput"
                  ></textarea>
                  <label class="formGroupLabel">توضیحات</label>
                </div>
              </form>
            </div>
            <!--            :class="{ editForm: editMenu }"-->
            <div class="formSubmitBtnWrapper">
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && !editMenu"
                @click="send_data('save', true)"
              >
                افزودن متقاضی
              </div>
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && editMenu"
                @click="send_data('update', true)"
              >
                ویرایش متقاضی
              </div>
              <div class="formSubmitBtn" v-if="btn_loading">
                <span class="loading"></span>
              </div>
              <!--              <div class="formResetBtn" v-if="editMenu" @click="clear_form()">-->
              <!--                متقاضی جدید-->
              <!--              </div>-->
            </div>
          </div>
          <div
            v-if="showDetails"
            class="containerSideForm noteBookDetails"
            :class="{ show: showDetails }"
          >
            <div class="detailsHeader">
              <div class="headerRightOptions">
                <div
                  class="deleteButton"
                  @click="handel_del(noteBookDetails.id)"
                >
                  <i class="fas fa-trash"></i>
                </div>
                <div
                  class="editButton"
                  @click="handel_edit(noteBookDetails.id)"
                >
                  <i class="fas fa-edit"></i>
                </div>
              </div>
              <div class="headerLeftOptions">
                <div class="backButton" @click="formCloseHandler('details')">
                  <i class="fas fa-arrow-left"></i>
                </div>
              </div>
            </div>
            <Skeletor v-if="LoadingSkeleton" class="detailsMainSk"/>
            <div v-if="!LoadingSkeleton" class="detailsMain">
              <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="fas fa-user"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">متقاضی:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.requester }}
                  </div>
                </div>
              </div>
              <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="fas fa-phone"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">شماره تماس:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.contact }}
                  </div>
                </div>
              </div>
              <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="fa-solid fa-tag"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">نوع تقاضا:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.main_category }}
                  </div>
                </div>
              </div>
              <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="fas fa-home"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">گروه:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.category }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  (noteBookDetails.category_en === 'villa_house' ||
                    noteBookDetails.category_en === 'garden' ||
                    noteBookDetails.category_en === 'land')
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-vector-square"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">متراژ زمین:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    از {{ noteBookDetails?.land_area }} متر تا
                    {{ noteBookDetails?.land_area_max }} متر
                  </div>
                </div>
              </div>
              <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="fas fa-expand"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">
                    <span
                      v-if="
                        noteBookDetails &&
                        (noteBookDetails.category_en === 'apartment' ||
                          noteBookDetails.category_en === 'Administrative' ||
                          noteBookDetails.category_en === 'industrial' ||
                          noteBookDetails.category_en === 'commercial')
                      "
                      >متراژ:</span
                    >
                    <span v-else>متراژ بنا:</span>
                  </div>
                  <div class="contentValue" v-if="noteBookDetails">
                    از {{ noteBookDetails?.building_area }} متر تا
                    {{ noteBookDetails?.building_area_max }} متر
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.category_en !== 'garden' &&
                  noteBookDetails.category_en !== 'land'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-calendar"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">سال ساخت:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.completion_date == 'new_build' ? 'نوساز' : `از ${noteBookDetails.completion_date}` }} تا
                    {{ noteBookDetails.completion_date_max == 'new_build' ? 'نوساز' : noteBookDetails.completion_date_max }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails && noteBookDetails.main_category_en != 'rent'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-clipboard"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">نوع سند:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.doc_type }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  (noteBookDetails.category_en === 'commercial' ||
                    noteBookDetails.category_en === 'industrial')
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-expand"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">متراژ دهنه ملک:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.width }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  (noteBookDetails.category_en === 'garden' ||
                    noteBookDetails.category_en === 'land')
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-expand"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">عرض کوچه:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.passage_width }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  (noteBookDetails.category_en === 'garden' ||
                    noteBookDetails.category_en === 'land')
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-expand"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">عرض زمین:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.width }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.category_en !== 'commercial' &&
                  noteBookDetails.category_en !== 'industrial' &&
                  noteBookDetails.category_en !== 'garden' &&
                  noteBookDetails.category_en !== 'land'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-bed"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">تعداد اتاق:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.bedroom }} اتاق
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.category_en !== 'commercial' &&
                  noteBookDetails.category_en !== 'industrial' &&
                  noteBookDetails.category_en !== 'garden' &&
                  noteBookDetails.category_en !== 'land'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-parking"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">پارکینگ:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.parking }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.category_en !== 'villa_house' &&
                  noteBookDetails.category_en !== 'commercial' &&
                  noteBookDetails.category_en !== 'industrial' &&
                  noteBookDetails.category_en !== 'garden' &&
                  noteBookDetails.category_en !== 'land'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-elevator"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">آسانسور:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.elevator }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.main_category_en !== 'rent' &&
                  (noteBookDetails.category_en == 'land' ||
                    noteBookDetails.category_en == 'Administrative')
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-user"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">نوع کاربری:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.sub_category }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.main_category_en !== 'rent' &&
                  noteBookDetails.category_en == 'villa'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-building"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">پروانه ساخت:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.building_license_date }}
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails && noteBookDetails.main_category_en != 'rent'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-dollar-sign"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">قیمت:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    از {{ noteBookDetails.total_price }} تومان تا
                    {{ noteBookDetails.total_price_max }} تومان
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails && noteBookDetails.main_category_en == 'rent'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-dollar-sign"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">مبلغ رهن:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    از {{ noteBookDetails.mortgage_price }} تومان تا
                    {{ noteBookDetails.mortgage_price_max }} تومان
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails && noteBookDetails.main_category_en == 'rent'
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-dollar-sign"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">مبلغ اجاره:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    از {{ noteBookDetails.rent_price }} تومان تا
                    {{ noteBookDetails.rent_price_max }} تومان
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="
                  noteBookDetails &&
                  noteBookDetails.districts &&
                  noteBookDetails.length > 0
                "
              >
                <div class="thumbIcon">
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">منطقه:</div>
                  <div class="contentValue">
                    <span v-for="(v, i) in noteBookDetails.districts" :key="i"
                      >{{ v }} -</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="detailsThumb"
                v-if="noteBookDetails && noteBookDetails.details"
              >
                <div class="thumbIcon">
                  <i class="fas fa-file-text"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">توضیحات:</div>
                  <div
                    class="contentValue"
                    v-html="noteBookDetails?.details"
                  ></div>
                </div>
              </div>
              <!-- <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="fas fa-info-circle"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">وضعیت:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.status }}
                  </div>
                </div>
              </div> -->
              <div class="detailsThumb">
                <div class="thumbIcon">
                  <i class="far fa-calendar"></i>
                </div>
                <div class="thumbContent">
                  <div class="contentTitle">تاریخ ثبت:</div>
                  <div class="contentValue" v-if="noteBookDetails">
                    {{ noteBookDetails.created_at }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!LoadingSkeleton" class="detailsThumbUttons">
              <div class="buttonsWrapper">
                <div
                  class="detailBtn mySearch"
                  @click="find_post(noteBookDetails, 'me')"
                >
                  <div class="btnIcon">
                    <i class="fas fa-search-plus"></i>
                  </div>
                  <div class="btnTitle">فایل‌های خودم</div>
                </div>
                <div
                  class="detailBtn allSearch"
                  @click="find_post(noteBookDetails, 'all')"
                >
                  <div class="btnIcon">
                    <i class="fas fa-search"></i>
                  </div>
                  <div class="btnTitle">شمال املاک</div>
                </div>
                <a
                  :href="`sms:${noteBookDetails?.contact}`"
                  class="detailBtn smsButton"
                >
                  <div class="btnIcon">
                    <i class="fas fa-message"></i>
                  </div>
                  <div class="btnTitle">پیامک</div>
                </a>
                <a
                  :href="`tel:${noteBookDetails?.contact}`"
                  class="detailBtn callButton"
                >
                  <div class="btnIcon">
                    <i class="fas fa-phone"></i>
                  </div>
                  <div class="btnTitle">تماس</div>
                </a>
              </div>
            </div>
          </div>
          <div class="noteBookContentMain">
            <div class="headerTabsList">
              <div class="tabsWrapper" :class="fillter.main_category">
                <div class="tabSwitch"></div>
                <div class="tabThumb all" @click="filterTabHandler('all')">
                  همه متقاضی‌ها
                </div>
                <div class="tabThumb trade" @click="filterTabHandler('trade')">
                  خرید
                </div>
                <div class="tabThumb rent" @click="filterTabHandler('rent')">
                  اجاره
                </div>
              </div>
            </div>
            <div class="headerSearchInput">
              <div class="searchInputWrapper">
                <input
                  type="search"
                  class="searchInput"
                  inputmode="search"
                  enterkeyhint="search"
                  placeholder="جستجوی متقاضی"
                />
                <div class="searchBtn">
                  <i class="fas fa-search"></i>
                </div>
              </div>
            </div>
            <div>
              <div v-if="LoadingSkeleton" class="noteBookThumbsList">
                <Skeletor v-for="i in 6" :key="i" class="noteBookThumbSk"/>
              </div>
              <div v-if="!LoadingSkeleton && data_list.length > 0" class="noteBookThumbsList">
                <div
                  class="noteBookThumb"
                  v-for="(contact, i) in data_list"
                  :key="i"
                >
                  <div class="thumbOptionsWrapper">
                    <div class="thumbOptions nameOption">
                      <div class="optionTitleWrapper">
                        <div class="optionTitleIcon">
                          <i class="fas fa-user"></i>
                        </div>
                      </div>
                      <div class="optionValue">{{ contact.requester }}</div>
                    </div>
                    <a
                      :href="`tel:${contact.contact}`"
                      class="thumbOptions phoneOption"
                    >
                      <div class="optionTitleWrapper">
                        <div class="optionTitleIcon">
                          <i class="fas fa-phone"></i>
                        </div>
                      </div>
                      <div class="optionValue">{{ contact.contact }}</div>
                    </a>
                    <div class="thumbOptions categoryOption">
                      <div class="optionTitleWrapper">
                        <div class="optionTitleIcon">
                          <i class="fas fa-exchange-alt"></i>
                        </div>
                      </div>
                      <div class="optionValue">
                        {{ contact.main_category }} - {{ contact.category }}
                      </div>
                    </div>
                    <div class="thumbOptions dateOption">
                      <div class="optionTitleWrapper">
                        <div class="optionTitleIcon">
                          <i class="far fa-calendar"></i>
                        </div>
                      </div>
                      <div class="optionValue">{{ contact.created_at }}</div>
                    </div>
                    <div class="thumbOptions dateOption">
                      <div class="optionTitleWrapper">
                        <div class="optionTitleIcon">
                          <i class="far fa-check-square"></i>
                        </div>
                      </div>
                      <div class="optionValue">{{ contact.status }}</div>
                    </div>
                  </div>
                  <div class="thumbBtnsWrapper">
                    <div
                      class="thumbDetailsBtn"
                      @click="formTypeHandler('details', contact)"
                    >
                      جزئیات
                    </div>
                  </div>
                </div>
              </div>
              <div class="loadeMoreLoader" v-if="loadmore_loading && !LoadingSkeleton && data_list.length > 0">
                <span class="custom-loader"></span>
              </div>
              <div
                v-if="data_list.length == 0 && !LoadingSkeleton"
                class="justify-center align-center mt-4"
                style="text-align: center; height: 90%"
              >
                <img
                  src="/img/notfound.png"
                  alt="Alt text"
                  width="320"
                  height="280"
                />
                <p class="noResultContent">متقاضی یافت نشد!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import "vue3-toastify/dist/index.css";
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";
import { nextTick } from "vue";

export default {
  components: {
    Skeletor,
  },
  data() {
    return {
      // publicPath: process.env.VUE_APP_PUBLIC_PATH,
      editMenu: false,
      LoadingSkeleton: true,
      editModel: false,
      color: "#2dc653",
      windowsGEt: 0,
      isBackAction: false,
      loadMoreTrigger: null,
      noteBookDetails: null,
      form: {
        user_id: "",
        nickname: "",
        mobile: "",
        status: "",
        main_category: "trade",
        category: "apartment",
        land_area: "",
        land_area_max: "",
        building_area: "",
        building_area_max: "",
        completion_date: "",
        completion_date_max: "",
        doc_type: "",
        width: "",
        bedroom: "",
        parking: "",
        passage_width: "",
        sub_category: "",
        building_license_date: "",
        elevator: "no",
        details: "",
        total_price: "",
        total_price_max: "",
        mortgage_price: "",
        mortgage_price_max: "",
        rent_price: "",
        rent_price_max: "",
        state: 26,
        city: 317,
        districts: [],
      },
      front_show: {
        land_area: "",
        land_area_max: "",
        building_area: "",
        building_area_max: "",
        width: "",
        passage_width: "",
        sub_category_list: [],
        total_price: "",
        total_price_max: "",
        mortgage_price: "",
        mortgage_price_max: "",
        rent_price: "",
        rent_price_max: "",
        district_list: [],
      },
      selectFocus: {
        user_id: false,
        status: false,
        main_category: false,
        category: false,
        completion_date: false,
        completion_date_max: false,
        doc_type: false,
        bedroom: false,
        parking: false,
        sub_category: false,
        building_license_date: false,
        elevator: false,
        districts: false,
      },
      data_list: [],
      isLoading: false,
      loadmore: true,
      loadmore_loading: false,
      formToggled: false,
      fillter: {
        main_category: "all",
        page: 1,
        search: "",
        per_page: 12,
      },
      users_list: [],
      usersFilter: {
        page: 1,
        search: "",
        role: "customer",
        prePage: 12,
      },
      fillter_find: {
        main_category: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        parking: false,
        storage: false,
        elevator: false,
        photo: false,
        newProperty: false,
        special: false,
        fast: false,
        request: false,
        advertiser: "all",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: 12,
        single_unit: false,
        two_room: false,
        three_room: false,
        pent: false,
        doblex: false,
        doc_ismelk: false,
        les_sad: false,
        more_sad: false,
      },
    };
  },
  computed: {
    showForm() {
      return this.$route.query.add === "active"
    },
    showDetails() {
      const active = this.$route.query.details;
      return active ? true : false;
    },
  },

  methods: {
    onMobileInput(e) {
      let value = e.target.value.replace(/\D/g, "");
      value = value.slice(0, 11);
      this.form.mobile = value;
      e.target.value = value;
    },
    formatNumber(num) {
      return Number(num).toLocaleString();
    },
    inputFocusHandler(field) {
      this.selectFocus[field] = true;
    },
    inputBlurHandler(field) {
      this.selectFocus[field] = false;
    },
    load_users() {
      let self = this;
      this.helperPost("branch-users-list", { role: "contact" }).then((r) => {
        if (r.data.result) {
          self.users_list = r.data.list;
        }
      });
    },
    filterTabHandler(tab) {
      this.fillter.main_category = tab;
      this.data_list = [];
      this.load_data("first");
    },
    formTypeHandler(type, details = null) {
      this.formType = type;
      this.noteBookDetails = details;

      this.get_district();

      // let windowWidth = window.innerWidth;
      // if (windowWidth < 1000) {
      // }
      this.formOpenHandler(type);
    },
    formOpenHandler(type) {
      const query = { ...this.$route.query };
      delete query.add;
      delete query.details;

      if (type == "form") query.add = "active";
      else if (type == "details") query.details = this.noteBookDetails.id;

      this.$router.push({ query });
    },
    formCloseHandler() {
      history.back();
    },
    editmenuHandler() {
      this.editMenu = true;
    },

    handel_edit(id) {
      let windowWidth = window.innerWidth;
      if (windowWidth < 1000) {
        this.formTypeHandler("form");
      }
      document.body.style.overflow = "hidden";
      // if (window.innerWidth <= 1250) {
      //   this.closeBtn1 = true;
      // }
      let self = this;
      this.helperGet("info-request", "id=" + id).then((res) => {
        self.form = res.data.data;
        self.front_show = {
          building_area: self.formatNumber(res.data.data?.building_area),
          building_area_max: self.formatNumber(
            res.data.data?.building_area_max
          ),
          land_area: self.formatNumber(res.data.data?.land_area),
          land_area_max: self.formatNumber(res.data.data?.land_area_max),
          width: self.formatNumber(res.data.data?.width),
          mortgage_price: self.formatNumber(res.data.data?.mortgage_price),
          mortgage_price_max: self.formatNumber(
            res.data.data?.mortgage_price_max
          ),
          rent_price: self.formatNumber(res.data.data?.rent_price),
          rent_price_max: self.formatNumber(res.data.data?.rent_price_max),
          total_price: self.formatNumber(res.data.data?.total_price),
          total_price_max: self.formatNumber(res.data.data?.total_price_max),
          sub_category_list: res.data.data?.sub_category_list,
        };
        self.editMenu = true;
        if (windowWidth < 1000) {
          self.formTypeHandler("form");
        }
      });
    },
    handel_del(uid) {
      this.$swal
        .fire({
          title: "فایل حذف گردد؟",
          text: "پس از این عملیات فایل برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("delete-request", { foo: uid })
                .then((r) => {
                  if (r.data.result == 1) {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.load_data("first");
                    self.formCloseHandler("details");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    send_data(mode, close = false) {
      if (this.form.nickname == "") {
        toast("نام متقاضی را وارد کنید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (this.form.mobile == "") {
        toast("شماره تماس متقاضی وارد نشده است", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (!/^09\d{9}$/.test(this.form.mobile)) {
        toast("فرمت شماره تماس وارد شده صحیح نمی باشد", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (this.form.building_area == "" || this.form.building_area_max == "") {
        toast("متراژ درخواست وارد نشده است", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (this.form.completion_date == "" || this.form.completion_date_max == "") {
        toast("متراژ درخواست وارد نشده است", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (this.form.main_category != "rent" && this.form.doc_type == "") {
        toast("نوع سند درخواست وارد نشده است", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }

      let url = "update-request";
      if (mode == "save") url = "save-request";

      this.btn_loading = true;
      this.helperPost(url, this.form).then((r) => {
        if (r.data.result == 1) {
          toast(r.data.msg, {
            type: "success",
            dangerouslyHTMLString: true,
          });
          this.clear_form();
          this.load_data("first");
        } else {
          toast(r.data.result, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        this.btn_loading = false;
      })
        .catch(err => {
          console.error(err);
          this.btn_loading = false;
          toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
            type: "error",
            dangerouslyHTMLString: true,
          });
      });
      let windowWidth = window.innerWidth;
      if (windowWidth < 1000 && close) {
        this.formCloseHandler("form");
      }
    },
    clear_form() {
      (this.form = {
        user_id: "0",
        nickname: "",
        mobile: "",
        status: "",
        main_category: "trade",
        category: "apartment",
        land_area: "",
        land_area_max: "",
        building_area: "",
        building_area_max: "",
        completion_date: "",
        completion_date_max: "",
        doc_type: "",
        width: "",
        bedroom: "",
        parking: "",
        passage_width: "",
        sub_category: "",
        building_license_date: "",
        elevator: "no",
        details: "",
        total_price: "",
        total_price_max: "",
        mortgage_price: "",
        mortgage_price_max: "",
        rent_price: "",
        rent_price_max: "",
        state: 26,
        city: 317,
        districts: [],
      }),
        (this.front_show = {
          land_area: "",
          land_area_max: "",
          building_area: "",
          building_area_max: "",
          width: "",
          passage_width: "",
          sub_category_list: [],
          total_price: "",
          total_price_max: "",
          mortgage_price: "",
          mortgage_price_max: "",
          rent_price: "",
          rent_price_max: "",
          district_list: [],
        }),
        (this.editMenu = false);
      this.btn_loading = false;
    },
    load_data(param) {
      let self = this;
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.LoadingSkeleton = true;
        this.data_list = [];
        this.fillter.page = 1;
      }
      this.helperPost("request-list", self.fillter).then((r) => {
        if (r.data.result == 0) {
          // self.data_list = [];
          if (param != "first") {
            self.fillter.page -= 1;
          }
        } else {
          self.data_list = self.data_list.concat(r.data.list.list);
          if (r.data.list.total_page == self.fillter.page) {
            self.loadmore = false;
          }
          if (this.showDetails) {
            const selected = this.$route.query.details;
            this.noteBookDetails = this.data_list.find(data => {
              return data.id == selected
            })
          }
        }
        self.LoadingSkeleton = false;
        self.loadmore_loading = false;

        console.log("self.data_list", self.data_list);
      });
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_data(); // متد لود داده‌هات
        }
      }
    },
    increment() {
      this.form.bedroom++;
    },
    decrement() {
      if (this.form.bedroom > 0) {
        this.form.bedroom--;
      }
    },

    closeBtn() {
      history.back();
      document.body.style = "overflow-y: auto;";
    },

    openEdit() {
      history.pushState(null, "", location.href);
      this.editMenu = true;
      document.body.style = "overflow: hidden;";
    },

    closeEdit() {
      if (!this.isBackAction) {
        history.back();
      }
      this.editMenu = false;
      document.body.style = "overflow: auto;";
    },

    loadTheme() {
      const width = window.innerWidth;
      if (width >= 1250) {
        this.color = "#2dc653";
      } else {
        this.color = "#f5f5f5";
      }
    },
    // checkWindowSize() {
    //   if (window.innerWidth <= 1250) {
    //     this.editMenu = false;
    //   } else {
    //     this.editMenu = true;
    //   }

    //   this.windowsGEt = window.innerWidth;

    //   console.log(window.innerWidth, this.editMenu);
    // },
    get_state() {
      let self = this;
      this.helperGet("get-state").then((r) => {
        self.front_show.state = r.data;
      });
    },

    get_city() {
      let self = this;
      this.helperGet("get-city", "id=" + this.form.state).then((r) => {
        self.front_show.city = r.data;
      });
    },

    get_district() {
      let self = this;
      this.helperGet("get-district?id=317").then((r) => {
        self.front_show.district_list = r.data;
      });
    },
    numberInputHandler(event, field) {
      this.front_show[field] = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form[field] = event.target.value.replace(/[^\d.-]/g, "");
    },
    building_area_input(event) {
      this.front_show.building_area = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form.building_area = event.target.value.replace(/[^\d.-]/g, "");
    },
    width_input(event) {
      this.front_show.width = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form.width = event.target.value.replace(/[^\d.-]/g, "");
    },

    land_area_input(event) {
      this.front_show.land_area = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form.land_area = event.target.value.replace(/[^\d.-]/g, "");
    },
    total_price_input(event) {
      this.front_show.total_price = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form.total_price = event.target.value.replace(/[^\d.-]/g, "");
    },
    mortgage_price_input(event) {
      this.front_show.mortgage_price = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form.mortgage_price = event.target.value.replace(/[^\d.-]/g, "");
    },
    rent_price_input(event) {
      this.front_show.rent_price = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form.rent_price = event.target.value.replace(/[^\d.-]/g, "");
    },

    get_sub_category() {
      if (this.form.category == "land") {
        let self = this;
        this.helperGet(
          "get-post-sub-category",
          "category=" + this.form.category
        ).then((r) => {
          self.front_show.sub_category_list = r.data.rows;
          if (r.data.rows.length > 0)
            self.form.sub_category = r.data.rows[0].value;
        });
      }
    },
    find_post(contact, param) {
      this.fillter_find.main_category = contact.main_category_en;
      this.fillter_find.category = contact.category_en;
      this.fillter_find.building_area = contact.building_area;
      this.fillter_find.bedroom = contact.bedroom;
      this.fillter_find.land_area = contact.land_area;

      if (param == "me") this.fillter_find.branch_id = contact.branch_id;
      // console.log(contact,param)
      localStorage.removeItem("post_fillter");
      this.$store.commit("post_fillter_set", [this.fillter_find, []]);
      this.$router.push({ path: "/category" });
    },
  },
  beforeUnmount() {
    const wrap = this.$refs.scrollbar?.wrapRef;
    if (wrap) {
      wrap.removeEventListener("scroll", this.handleScroll);
    }
  },
  async mounted() {
    this.load_data("first");
    this.load_users();
    this.get_district();

    setInterval(() => {
      this.loadTheme();
    }, 100);
    await nextTick();
    this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    this.$nextTick(() => {
      const wrap = this.$refs.scrollbar?.wrapRef;
      if (wrap) {
        wrap.addEventListener("scroll", this.handleScroll);
      }
    });
    // const observer = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.isIntersecting) {
    //       this.load_data();
    //     }
    //   },
    //   { threshold: 1.0 }
    // );
    // if (this.loadMoreTrigger) {
    //   observer.observe(this.loadMoreTrigger);
    // }
  },
  watch: {
    contacts: {
      handler(newContacts) {
        this.filteredContacts = newContacts;
      },
      immediate: true,
    },
    showForm() {
      if (!this.showForm) {
        this.clear_form();
      }
    },
    showDetails() {
      if (this.showDetails) {
        if (this.noteBookDetails == null) {
          this.LoadingSkeleton = true;
          const selected = this.$route.query.details;
          this.noteBookDetails = this.data_list.find(data => {
            return data.id == selected
          })
          setTimeout(() => {
            this.LoadingSkeleton = false;
          }, 1500)
        }
      } else {
        this.noteBookDetails = null;
      }
    }
  },
};
</script>

<style scoped lang="scss">
/* استایل‌های شما */
.loader2 {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.numberInput {
  direction: ltr !important;
  text-align: left !important;
}
.thumbDetailsBtn,
.deleteButton,
.editButton,
.backButton {
  cursor: pointer;
}

.noResultContent {
  text-align: center;
  font-size: 0.95rem;
}

.phoneBookMain {
  .phoneBookMainContainer {
    .containerSideForm {
      .formMain {
        .addPhoneForm {
          &.addRequestForm {
            padding-top: 6px;

            .groupFlexWrapper {
              margin-bottom: 32px;
              .groupFlexLabel {
                .groupLabel {
                  font-size: 1rem;
                  margin: -8px 8px 14px 0;
                  display: block;

                  span {
                    color: #f00;
                  }
                }
              }
              .groupFlex {
                .formGroup {
                  margin-bottom: 0 !important;
                }
              }
            }

            .formGroup {
              position: relative;

              &:not(:last-child) {
                margin-bottom: 32px;
              }

              &.focused {
                .formGroupLabel {
                  top: 0 !important;
                  color: #0096c7 !important;
                  font-size: 14px !important;
                }

                :deep(.el-select) {
                  .el-select__wrapper {
                    border-color: #0096c7 !important;
                  }
                }
              }

              &.filled {
                .formGroupLabel {
                  top: 0 !important;
                }
              }

              .formGroupLabel {
                font-family: "iranyekanB", sans-serif;
                position: absolute;
                top: 50%;
                right: 10px;
                transform: translateY(-50%);
                padding: 0 6px;
                background: #fff;
                width: fit-content;
                margin: 0;
                font-size: 12px;
                transition: all 0.15s ease-in-out;
                pointer-events: none;
                z-index: 2;
                white-space: nowrap;

                span {
                  color: #f00;
                }
              }

              :deep(.el-select) {
                .el-select__wrapper {
                  width: 100% !important;
                  height: 50.4px !important;
                  padding: 12px !important;
                  font-size: 1rem !important;
                  border-radius: 12px !important;
                  transition: all 0.15s ease-in-out;
                  background: transparent !important;
                  border: 1px solid #dcdfe6 !important;
                  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1) !important;
                }
              }

              .formGroupTextInput {
                position: relative;
                width: 100%;
                height: 50.4px !important;
                padding: 12px !important;
                font-size: 1rem !important;
                transition: all 0.15s ease-in-out;
                z-index: 1;
                border-radius: 12px !important;
                border: 1px solid rgb(209, 213, 219) !important;
                background: #fff !important;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);

                &:focus {
                  border-color: #0096c7 !important;
                }
              }

              .formGroupTextInput:focus ~ .formGroupLabel {
                top: 0 !important;
                color: #0096c7;
                font-size: 14px !important;
              }

              .formGroupTextInput:not(:placeholder-shown) ~ .formGroupLabel {
                top: 0 !important;
              }

              textarea.formGroupTextInput {
                height: auto !important;
              }

              textarea.formGroupTextInput ~ .formGroupLabel {
                top: 10px;
                transform: translateY(0);
              }

              textarea.formGroupTextInput:focus ~ .formGroupLabel {
                transform: translateY(-50%);
              }
            }
          }
        }
      }
    }
  }
}

.dark {
  .phoneBookMain {
    .phoneBookMainContainer {
      .containerSideForm {
        .formMain {
          .addPhoneForm {
            &.addRequestForm {
              .groupFlexWrapper {
                .groupFlexLabel {
                  .groupLabel {
                    color: #fff;
                  }
                }
              }
              .formGroup {
                &.focused {
                  .formGroupLabel {
                    color: #0096c7 !important;
                  }

                  :deep(.el-select) {
                    .el-select__wrapper {
                      border-color: #0096c7 !important;
                    }
                  }
                }

                :deep(.el-select) {
                  .el-select__wrapper {
                    box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1) !important;
                    border-color: #2a3b47 !important;
                    background: #101a23 !important;
                    color: #fff !important;
                  }
                }

                .formGroupTextInput {
                  box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1) !important;
                  border-color: #2a3b47 !important;
                  background: #101a23 !important;
                  color: #fff !important;

                  &:focus {
                    border-color: #0096c7 !important;
                  }
                }

                .formGroupLabel {
                  background: #101a23 !important;
                  color: #fff !important;
                }

                .formGroupTextInput:focus ~ .formGroupLabel {
                  color: #0096c7 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.detailsMainSk {
  width: 100%;
  border-radius: 8px;
  height: 600px;
  background: rgb(163, 219, 213);
}

.noteBookThumbSk {
  width: 100%;
  height: 240px;
  border-radius: 16px;
  background: rgb(163, 219, 213);
}
</style>
